import _regeneratorRuntime from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/builds/7ChVgkMg/0/gcp-backend/tea-h5/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx } from "vue";
var _hoisted_1 = {
  class: "point-history"
};
import PointBalance from "@/components/points/PointBalance.vue";
import PointList from "@/components/points/PointList.vue";
import NoticeBar from "@/components/tips/NoticeBar.vue";
import Dialog from "@/components/dialog/dialog";
import { getExpiringPoints } from "@/api/reward";
import { ref, computed, watch, onMounted } from "vue";
import { getUserId } from "@/utils/authUtil";
import { formatDateWithTZ } from "@/utils/format";
import { nth } from "@/utils/tools";
import PagePopupLayout from "@/layouts/PagePopupLayout.vue";
import { PopupPageKey } from "@/constant/pageKey";
import { useUserStore } from "@/store/userStore";
import { useI18n } from "vue-i18n";
export default {
  __name: 'PontHistoryPoupup',
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  emits: ["update:show"],
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var props = __props;
    var emit = __emit;
    var showPopup = computed({
      get: function get() {
        return props.show;
      },
      set: function set(val) {
        emit("update:show", val);
      }
    });
    function showTipsDetail() {
      Dialog.confirm({
        title: t("zeroClearingRole"),
        desc: noticeTextDetail.value,
        okText: t("gotIt"),
        withoutCancel: true
      });
    }
    var isShowExpireTips = ref(false);
    var clearTime = ref(0);
    var expiringPoints = ref(0);
    var noticeText = computed(function () {
      if (clearTime.value > 0 && expiringPoints.value > 0) {
        var days = Math.ceil((clearTime.value - Date.now()) / (24 * 60 * 60 * 1000));
        return t("pointsWillBeCleared", [expiringPoints.value, days]);
      } else {
        return "";
      }
    });
    var noticeTextDetail = computed(function () {
      if (clearTime.value > 0 && expiringPoints.value > 0) {
        return t("noticeTextDetailDesc", [expiringPoints.value, formatDateWithTZ(clearTime.value, "MMMM D"), nth(formatDateWithTZ(clearTime, "D"))]);
      } else {
        return "";
      }
    });
    function getData() {
      return _getData.apply(this, arguments);
    }
    function _getData() {
      _getData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getExpiringPoints({
                user_id: getUserId()
              });
            case 2:
              res = _context.sent;
              if (res.isOK) {
                clearTime.value = res.data.clear_time;
                expiringPoints.value = res.data.expiring_points;
                isShowExpireTips.value = res.data.is_show_tips;
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _getData.apply(this, arguments);
    }
    function getPiontData() {
      return _getPiontData.apply(this, arguments);
    }
    function _getPiontData() {
      _getPiontData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var userStore;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              userStore = useUserStore();
              userStore.setUserAsset();
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return _getPiontData.apply(this, arguments);
    }
    var pointListRef = ref();
    watch(showPopup, function () {
      if (showPopup.value) {
        var _pointListRef$value;
        getData();
        getPiontData();
        (_pointListRef$value = pointListRef.value) === null || _pointListRef$value === void 0 || _pointListRef$value.reset();
      }
    });
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(PagePopupLayout, {
        show: showPopup.value,
        "onUpdate:show": _cache[0] || (_cache[0] = function ($event) {
          return showPopup.value = $event;
        }),
        title: _ctx.$t('pointsHistory'),
        "page-key": _unref(PopupPageKey).POINT_HISTORY
      }, {
        default: _withCtx(function () {
          return [_createElementVNode("div", _hoisted_1, [isShowExpireTips.value ? (_openBlock(), _createBlock(NoticeBar, {
            key: 0,
            text: noticeText.value,
            mode: "link",
            onClick: showTipsDetail
          }, null, 8, ["text"])) : _createCommentVNode("", true), _createVNode(PointBalance), _createVNode(PointList, {
            ref_key: "pointListRef",
            ref: pointListRef
          }, null, 512)])];
        }),
        _: 1
      }, 8, ["show", "title", "page-key"]);
    };
  }
};